import { useEffect, useState } from "react";
import Thread from "../thread/Thread";
import axios from "axios";
import { clientNetwork, profileContract, stacksApi } from "../../lib/constants";

const Likes = ({ index, liked_txid, setReplyOpen, userSettings,
    playList, setPlayList, openMediaPlayer, setOpenMediaPlayer,
    selectedChimeTx, setSelectedChimeTx, mediaCurrentTime, setMediaCurrentTime,

    setShowUserContractDeployModal,
    setShowWoopsModal,
    setOpenConfirmModal,
    userContractStatus,

    txId,
    setTxId,
    tx_Id,
    setTx_Id
}) => {
    const [base, setbase] = useState('');
    const [hex, setHex] = useState('');
    const [sender, setSender] = useState('');

    async function loadOut() {
        let response = (await axios.get(`${stacksApi[clientNetwork]}/extended/v1/tx/${liked_txid}`)).data;
        const { sender_address, events } = response;
        response = events.filter((res) => {
            if (res.contract_log && res.contract_log.contract_id && res.contract_log.contract_id === `${sender_address}.${profileContract}`) {
                return res;
            }
            return false;
        });
        const { 0: { tx_id, contract_log: { value: { hex } } } } = response;
        setbase(tx_id);
        setHex(hex);
        setSender(sender_address);
    }

    useEffect(() => {
        loadOut()
    }, [liked_txid])

    useEffect(() => {

    }, [base, hex, sender])

    return (
        <>
            {base && hex && sender && <Thread baseTxId={base} hex={hex} setReplyOpen={setReplyOpen} profilePrincipal={sender} index={index} key={base} threading={false} userSettings={userSettings}
                playList={playList} setPlayList={setPlayList} openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer}
                selectedChimeTx={selectedChimeTx} setSelectedChimeTx={setSelectedChimeTx} mediaCurrentTime={mediaCurrentTime} setMediaCurrentTime={setMediaCurrentTime}

                setShowUserContractDeployModal={setShowUserContractDeployModal}
                setShowWoopsModal={setShowWoopsModal}
                setOpenConfirmModal={setOpenConfirmModal}
                userContractStatus={userContractStatus}

                txId={txId}
                setTxId={setTxId}
                tx_Id={tx_Id}
                setTx_Id={setTx_Id}
            />}
        </>
    )
}

export default Likes;